import { z } from "zod"

import { FAQCategorySchema, LanguageIso6391Schema } from "./enum"

export const FAQInputSchema = z
  .object({
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    category: z.lazy(() => FAQCategorySchema),
    lang: z.lazy(() => LanguageIso6391Schema),
    question: z.string(),
    answer: z.string(),
  })
  .strict()
export type FAQInputValidationType = z.infer<typeof FAQInputSchema>
